// Visible alpha bounds (>32) of the unchanged 260px drawings. Normalize artwork,
// not the equal-sized transparent canvases; keep a common visible baseline.
export const loadingPoses = [
  { id: 'R09_01', bounds: [32, 33, 255, 243] },
  { id: 'R08_01', bounds: [50, 48, 220, 227] },
  { id: 'R03_01', bounds: [28, 123, 232, 237] },
].map(({ id, bounds: [left, top, right, bottom] }, index) => {
  const scale = 136 / Math.max(right - left + 1, bottom - top + 1);
  return { id, style: {
    '--pose': index,
    width: `${260 * scale}px`,
    bottom: `${12 - (259 - bottom) * scale}px`,
    transform: `translateX(-${(left + right + 1) / 520 * 100}%)`,
  } };
});
